import { useQuery } from '@tanstack/react-query';

import { chatSettingsApi } from '../api/chat-settings-api';

import { chatSettingsKeys } from './chat-settings-keys';

/** Discounts a trigger's discount step can name; loaded when the dialog has one. */
export function useTriggerDiscounts(storeId: string, enabled: boolean) {
  return useQuery({
    queryKey: chatSettingsKeys.discounts(storeId),
    queryFn: () => chatSettingsApi.discounts(storeId),
    enabled,
  });
}
